import { datadogLogs } from '@datadog/browser-logs'
import version from '../version';
import strings from '../resources/strings';

const logToConsole = "REACT_APP_LOG_TO_CONSOLE" in process.env && process.env.REACT_APP_LOG_TO_CONSOLE === "true" ? true : false;
const logToDatadog = "REACT_APP_LOG_TO_DATADOG" in process.env && process.env.REACT_APP_LOG_TO_DATADOG === "true" ? true : false;

function convertToString(obj) {
    if (obj === undefined) {
        return 'undefined';
    }    
    if (obj === null || typeof obj === 'string' || typeof obj === 'number') {
        return String(obj);
    }
    if (Array.isArray(obj)) {
        return '[' + Array.prototype.map.call(obj, convertToString).join(', ') + ']';
    }
    if (obj instanceof HTMLElement) {
        return '<' + obj.nodeName.toLowerCase() + '>';
    }
    if (obj instanceof Text) {
        return '"' + obj.nodeValue + '"';
    }
    if (typeof obj === 'object') {
        return JSON.stringify(obj);
    }
    if (obj.toString) {
        return obj.toString();
    }

    return String(obj);
};

function formatString(args) {
    let buffer = "";
    args.forEach(arg => {
        buffer += convertToString(arg);
    });

    return buffer;
}

var initialize = function() {
    if (logToDatadog) {
        datadogLogs.init({
            clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
            site: "datadoghq.com",
            service: "workflow-app",
            env: "REACT_APP_ENVIRONMENT" in process.env ? process.env.REACT_APP_ENVIRONMENT : "development",
            version: strings.format("%s %s", version.version, version.buildNumber),
            forwardErrorsToLogs: true,
            sampleRate: 100
        });
    }

    // intercept console.log, console.error, etc calls so that we
    // can store the output and send it to server
    console._log = console.log;
    console.log = function(...args) {
        if (logToDatadog) {
            datadogLogs.logger.log(formatString(args));
        }
        if (logToConsole) {
            console._log(...args);
        }
    }

    console._info = console.info;
    console.info = function(...args) {
        if (logToDatadog) {
            datadogLogs.logger.info(formatString(args));
        }
        if (logToConsole) {
            console._info(...args);
        }
    }

    console._error = console.error;
    console.error = function(...args) {
        if (logToDatadog) {
            datadogLogs.logger.error(formatString(args));
        }
        if (logToConsole) {
            console._error(...args);
        }
    }

    console._warn = console.warn;
    console.warn = function(...args) {
        if (logToDatadog) {
            datadogLogs.logger.warn(formatString(args));
        }
        if (logToConsole) {
            console._warn(...args);
        }
    }

    console._debug = console.debug;
    console.debug = function(...args) {
        if (logToDatadog) {
            datadogLogs.logger.debug(formatString(args));
        }
        if (logToConsole) {
            console._debug(...args);
        }
    }

    console._trace = console.trace;
    console.trace = function(...args) {
        if (logToDatadog) {
            datadogLogs.logger.debug(formatString(args)); // need to use debug as there is no verbose/trace call
        }
        if (logToConsole) {
            console._trace(...args);
        }
    }
};

export default {
    initialize
};
